<template>
    <div>
		<!------------------------search----------------------->
		<el-tag type="danger">温馨提示：订单发货后，如客户端超过15天后还没有点击确认，系统自动将这些订单状态修改为已签收，待确认</el-tag>
        <el-form :inline="true" class="demo-form-inline" style="margin-top:15px">
        	<el-form-item style="width:10%">
	            <el-select v-model="query.status" filterable placeholder="订单状态">
	                <el-option v-for="(item,index) in statuslists" :key="index" :label="item.name" :value="item.id"></el-option>
	            </el-select> 
            </el-form-item>
            <el-form-item style="width:13%">
	            <el-select v-model="query.customer" clearable filterable remote reserve-keyword :remote-method="getCustomer" :loading="customerLoading" placeholder="请输入客户名称 / 简称" >
	          	    <el-option v-for="(item,index) in customerLists" :key="index" :label="item.showname" :value="item.id"></el-option>
	            </el-select> 
	        </el-form-item>
	        <el-form-item style="width:12%">
	            <el-select v-model="query.clerkid" filterable placeholder="全部销售员">
	                <el-option label="全部销售员" value="0"></el-option>
	                <el-option v-for="(item,index) in sellerLists" :key="index" :label="item.name" :value="item.id"></el-option>
	            </el-select> 
            </el-form-item>
            <el-form-item style="width:22%">
            	<el-date-picker v-model="query.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:100%"></el-date-picker>
            </el-form-item>
            <el-form-item ref="query" :model="query" style="width:15%">
            	<el-input placeholder="订单编号" v-model="query.key" @keyup.enter.native="getList" style="width:100%"></el-input>
            </el-form-item>
	        	 
            <el-form-item>
            	<el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
            </el-form-item>
        </el-form>
		
		<!----------------------订单信息列表------------------------------>
		<el-table :data="lists" border v-loading="listLoading">
			<el-table-column type="expand">
            <template slot-scope="props">
                <el-table :data="props.row.goods" border>
	                <el-table-column prop="productname" label="商品名称"></el-table-column>
	                <el-table-column prop="spec" label="规格" width="100"></el-table-column>
	                <el-table-column prop="num" label="数量" width="100"></el-table-column>
	                <el-table-column prop="unit" label="单位" width="100"></el-table-column>
	                <el-table-column prop="sell" label="售价" width="100"></el-table-column>
	                <el-table-column prop="ratio" label="折扣" width="100"></el-table-column>
	                <el-table-column prop="total" label="总价" width="100"></el-table-column>
	                <el-table-column label="类型" width="100" align="center">
	                    <template slot-scope="props">
	                        <el-tag type="success" v-if="props.row.isgive==0">消费</el-tag>
	                        <el-tag type="danger" v-if="props.row.isgive==1">赠送</el-tag>
	                    </template>
	                </el-table-column>
                </el-table>
            </template>
            </el-table-column>
		
            <el-table-column prop="ordernum" label="订单编号" width="90"></el-table-column>
            <el-table-column prop="customername" label="客户名称"></el-table-column>
            <el-table-column prop="amount" label="订单总价" align="center" width="100"></el-table-column>
            <el-table-column prop="clerkname" label="销售人员" align="center" width="100"></el-table-column>            
            <el-table-column prop="inputtime" label="下单时间" align="center" width="100"></el-table-column>
            <el-table-column label="审核单/发货单" align="center" width="120">
                <template slot-scope="props">
                    <el-button type="warning" size="small" circle v-if="props.row.verifyid!=''" @click="getverifyinfo(props.row.verifyid,'verify')">审</el-button>
                    <el-button type="success" size="small" circle v-if="props.row.productsellid!=''" @click="getverifyinfo(props.row.productsellid,'send')">发</el-button>
                </template>
            </el-table-column>
            <el-table-column label="状态" align="center" width="140">
            	<template slot-scope="props">
            		<el-tag type="danger" v-if="props.row.status==0">待审核</el-tag>
            		<el-tag type="danger" v-if="props.row.status==3">已审核，待发货</el-tag>
            		<el-tag type="warning" v-if="props.row.status==1">已发货，待签收</el-tag>
            		<el-tag type="warning" v-if="props.row.status==4">已签收，待确认</el-tag>
            		<el-tag type="success" v-if="props.row.status==5">已完成</el-tag>
            		<el-tag type="info" v-if="props.row.status==2">已取消</el-tag>
            	</template>
            </el-table-column>
            <el-table-column label="操作" width="130" align="center">
	            <template slot-scope="scope">
	            	<el-button type="primary" size="mini" icon="el-icon-circle-check-outline" v-if="scope.row.status==0 && actionauth.verify_run_order_info=='true'" style="margin-left:0;margin-bottom:10px" @click="sureverify(scope.row)">确认审核</el-button>
	            	<el-button type="primary" size="mini" icon="el-icon-edit" v-if="scope.row.status==0 && actionauth.edit_run_verify_order_info=='true'" style="margin-left:0;margin-bottom:10px" @click="editverify(scope.row)">修改订单</el-button>
	            	<el-button type="primary" size="mini" icon="el-icon-circle-check-outline" v-if="scope.row.status==3 && actionauth.send_run_order_info=='true'" style="margin-left:0;margin-bottom:10px" @click="editverify(scope.row)">去发货</el-button>
	            	<el-button type="danger" size="mini" icon="el-icon-circle-close-outline" v-if="scope.row.status==0 && actionauth.cannel_run_order_info=='true'" style="margin-left:0;margin-bottom:10px" @click="delCurrentorder(scope.row)">取消订单</el-button>
	            	<el-button type="danger" size="mini" icon="el-icon-circle-close-outline" v-if="scope.row.status==3 && actionauth.cannel_run_send_order_info=='true'" style="margin-left:0;margin-bottom:10px" @click="delCurrentorder(scope.row)">取消订单</el-button>
	            	<el-button type="primary" size="mini" icon="el-icon-circle-check-outline" v-if="scope.row.status==4" style="margin-left:0;margin-bottom:10px" @click="sureorder(scope.row)">确认完成</el-button>
	            </template>
            </el-table-column>
        </el-table>
		<div class="block">
            <!--分页begin-->
	        <el-pagination
	            @size-change="pageSizeChange"
	            @current-change="pageCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="total_rows">
            </el-pagination>
            <!--分页end-->
		</div>
        
        <!---------------- 订单详情商品详情修改 ----------------->
		<el-dialog title="待发货列表" :visible.sync="editorderDialog" width="80%" top="5vh">
			<el-button type="primary" icon="el-icon-circle-plus-outline" @click="addmoregoods">添加商品</el-button>
			<div style="margin-bottom:20px"></div>
			<template>
	    		<el-table :data="editparam.goods" v-loading="editgoodsLoading" border show-summary>
    				<el-table-column prop="productname" label="商品名称"></el-table-column>
    				<el-table-column prop="spec" label="规格" align="center" width="80"></el-table-column>
    				<el-table-column prop="num" label="数量" align="center" width="80">
    					<template slot-scope="scope">
        					<el-input v-model="scope.row.num" @blur="changeNum(scope.row,scope.$index)"></el-input>
      					</template>
    				</el-table-column>
    				<el-table-column prop="unit" label="单位" align="center" width="80">
    					<template slot-scope="scope">
        					<el-input v-model="scope.row.unit" readonly  @focus="changeUnit(scope.row)"></el-input>
      					</template>
    				</el-table-column>
    				<el-table-column prop="num" label="售价" align="center" width="80">
    					<template slot-scope="scope">
        					<el-input v-model="scope.row.sell"  @blur="changeSell(scope.row)"></el-input>
      					</template>
    				</el-table-column>
    				<el-table-column prop="discount" label="折扣" align="center" width="80">
    					<template slot-scope="scope">
        					<el-input v-model="scope.row.discount"  @blur="changeDiscount(scope.row)"></el-input>
      					</template>
    				</el-table-column>
    				<el-table-column prop="discount" label="折后单价" align="center" width="80">
    					<template slot-scope="scope">
        					<el-input v-model="scope.row.dis_sell"  @blur="changeDissell(scope.row)"></el-input>
      					</template>
    				</el-table-column>
    				<el-table-column prop="total" label="小计" align="center" width="80">
    					<template slot-scope="scope">
        					<el-input v-model="scope.row.total"  @blur="changeTotal(scope.row)"></el-input>
      					</template>
    				</el-table-column>
    				<el-table-column prop="warehousename" label="仓库" align="center" width="80">
    					<template slot-scope="scope">
        					<el-input v-model="scope.row.warehousename" readonly  @focus="changeWarehouse(scope.row)"></el-input>
      					</template>
    				</el-table-column>
    				<el-table-column prop="type" label="类型" align="center" width="80">
    					<template slot-scope="scope">
        					<el-input v-model="scope.row.type" readonly  @focus="changeType(scope.row)"></el-input>
      					</template>
    				</el-table-column>
    				<el-table-column label="操作" align="center" width="50">
					    <template slot-scope="scope">
					        <i class="el-icon-delete" @click="delCurrent(scope.row)"></i>
					    </template>
    				</el-table-column>
	    		</el-table>
    		</template>
    		
    		<div style="margin-top:30px"></div>
    		<el-form style="width:100%">
	    		<el-col :span="24">
	    			<el-col :span="6">
		    			<el-form-item label="交货日期">
		    				<el-col :span="15">
								<el-date-picker type="date" placeholder="请选择交货日期" v-model="editparam.deliverdate" value-format="yyyy-MM-dd" style="width:100%" @change="changedeliverdate()"></el-date-picker>		
							</el-col>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="单据编号">
							<el-col :span="15">
								<el-input v-model="editparam.documents" placeholder="单据编号" :disabled="true"></el-input>
							</el-col>
						</el-form-item>
				    </el-col>
	    			<el-col :span="6">
		    			<el-form-item label="应付金额">
		    				<el-col :span="15">
								<el-input placeholder="应付金额" v-model="editparam.real" @blur="changeReal">
									<template slot="append">元</template>
								</el-input>
							</el-col>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="优惠金额">
							<el-col :span="15">
								<el-input placeholder="优惠金额" v-model="editparam.derate" @blur="changeDerate">
									<template slot="append">元</template>
								</el-input>
							</el-col>
						</el-form-item>
					</el-col>
				</el-col>
				
				<el-col :span="24">
					<el-col :span="6">
						<el-form-item label="收款帐号">
				  			<el-select v-model="editparam.account" placeholder="未付款" filterable style="width:55%"  @change="changeaccount()">
								<el-option v-for="(item,index) in accountLists" :key="index" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="销售人员">
							<el-col :span="15">
								<el-select v-model="editparam.seller" filterable placeholder="请选择销售员" @change="changeseller()">
						            <el-option v-for="(item,index) in sellerLists" :key="index" :label="item.name" :value="item.id"></el-option>
						        </el-select>
							</el-col>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="经手人员">
							<el-col :span="14">
								<el-select v-model="editparam.sysmanager" filterable placeholder="请选择经手人" @change="changesysmanager()">
							    	<el-option v-for="(item,index) in sysmanagers" :key="index" :label="item.truename" :value="item.id"></el-option>
							    </el-select>
						    </el-col> 
					    </el-form-item>  
					</el-col>
					<el-col :span="6">
						<el-form-item label="送货方式">
							<el-col :span="16">
						    	<el-select v-model="editparam.shipping" filterable placeholder="请选择送货方式" @change="changeshipping()">
							    	<el-option v-for="(item,index) in shippings" :key="index" :label="item.name" :value="item.id"></el-option>
							    </el-select>
						    </el-col> 
					    </el-form-item>
					</el-col>	
				</el-col>
				
				<el-col :span="24">
					<el-col :span="6">
						<el-form-item label="物流单号" v-if="editparam.shipping==3">
							<el-col :span="16">
				  				<el-input placeholder="请填写快递单号" v-model="editparam.shippingcode" style="width:82%" @blur="changeshippingcode()"></el-input>
				  			</el-col>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="快递费用">
							<el-col :span="16">
				  				<el-input placeholder="请填写快递费用" v-model="editparam.express" style="width:82%" @blur="changeexpress()"></el-input>
				  			</el-col>
						</el-form-item>
					</el-col>
					<el-col v-if="editparam.shipping==3" :span="6">
						<el-form-item label="出库备注">
							<el-col :span="15">
								<el-input placeholder="出库备注" v-model="editparam.note" @blur="changenode()"></el-input>
							</el-col>
						</el-form-item>
					</el-col>
					<el-col v-if="editparam.shipping!=3" :span="6">
						<el-form-item label="出库备注">
							<el-col :span="16">
								<el-input placeholder="出库备注" v-model="editparam.note" style="width:82%" @blur="changenode()"></el-input>
							</el-col>
						</el-form-item>
					</el-col>
				</el-col>
				
			</el-form>
    		
    		<div slot="footer" class="dialog-footer">
            	<el-button @click="editorderDialog = false" v-if="this.editparam.ordertype=='send'">取 消</el-button>
            	<el-button type="primary" :loading="saveeditloading"  @click="saveedit" v-if="this.editparam.ordertype=='send'">确认出库</el-button>
            	<el-button type="primary" @click="editorderDialog = false" v-if="this.editparam.ordertype=='verify'">保存</el-button>
          	</div>
		</el-dialog>
		
		<!----------------------------- 单位信息列表 ------------------------------------------>
		<el-dialog title="单位选择" :visible.sync="unitlistsDialog">
	        <el-table :data="unitlists" style="width: 100%" v-loading="unitListLoading">
		        <el-table-column label="单位" prop="unit"></el-table-column>
		        <el-table-column label="售价" prop="sell"></el-table-column>
		        <el-table-column label="市场价" prop="market"></el-table-column>
		        <el-table-column label="选择" width="80">
		            <template slot-scope="scope">
		            	<el-button type="primary" size="mini" icon="el-icon-check"  @click="changeUnitSave(scope.row)"></el-button>
		            </template>
		        </el-table-column>
	        </el-table>
    	</el-dialog>
    	
    	<!---------------------------仓库列表--------------------------->
    	<el-dialog title="仓库选择" :visible.sync="warehouseDialog" width="40%">
	        <el-table :data="warehouselists" style="width: 100%" v-loading="warehouseListLoading">
		        <el-table-column label="仓库名称" prop="name"></el-table-column>
		        <el-table-column label="库存数量" prop="num">
		        	<template slot-scope="scope">
		            	<span v-if="scope.row.enough==1" style="color:#67C23A">{{scope.row.num}}</span>
		            	<span v-if="scope.row.enough==0" style="color:#F56C6C">{{scope.row.num}}</span>
		            </template>
		        </el-table-column>
		        <el-table-column label="选择" width="80">
		            <template slot-scope="scope">
		            	<el-button type="primary" size="mini" icon="el-icon-check"  @click="changeWareSave(scope.row)"></el-button>
		            </template>
		        </el-table-column>
	        </el-table>
        </el-dialog>
        
        <!---------------------------商品类型列表--------------------------->
        <el-dialog title="类型选择" :visible.sync="typeDialog" width="40%">
	        <el-table :data="typearr" style="width: 100%" v-loading="typeListLoading">
		        <el-table-column label="类型名称" prop="name"></el-table-column>
		        <el-table-column label="选择" width="80">
		            <template slot-scope="scope">
		            	<el-button type="primary" size="mini" icon="el-icon-check"  @click="changeTypeSave(scope.row)"></el-button>
		            </template>
		        </el-table-column>
	        </el-table>
        </el-dialog>
        
        
          <!--------------------------------打印信息 start ------------------------------->
		  <el-dialog title="确认打印" :visible.sync="printerDialog" width="80%" top="5vh">
		  	  <div style="width:100%;text-align:right">每页展示  <input type="text" v-model="rollpage"  v-on:blur="changepagevlaue()"  style="border-radius:5px;border:1px solid rgb(192, 196, 204);background-color:#fff;color:#606266;width:25px;height:30px;line-height:40px;padding:0 15px;margin-bottom:20px"/>  条</div>
		      <div id="printContent">
		      <div v-for="(iit,i) in prpage">
	      	  	  <span style="float:right">{{iit.id}}/{{allprintpage}}</span>
			      <DIV style="font-size:18px;padding-bottom:2px;margin-bottom:0" align="center" v-if="printsmodel.title==1"><STRONG>{{printsmodel.titlevalue}}</STRONG></DIV>        
			      <ul class="titlelists">
				  	  <li v-if="printsmodel.customer_name==1">客户名称：{{printlists.customername}}</li>
					  <li v-if="printsmodel.deliverdate==1">交货日期：{{printlists.deliverdate}}</li>
					  <li v-if="printsmodel.contactname==1">收货人姓名：{{printlists.contactname}}</li>
					  <li v-if="printsmodel.documents==1">单据编号：{{printlists.documents}}</li>
					  <li v-if="printsmodel.note==1">出库备注：{{printlists.note}}</li>
					  <li v-if="printsmodel.contactphone==1">收货电话：{{printlists.contactphone}}</li>
				      <li v-if="printsmodel.clerkname==1">销售人员：{{printlists.clerkname}}</li>
				      <li v-if="printsmodel.accountname==1">支付方式：<span >{{printlists.account}}</span></li>
				      <li v-if="printsmodel.address==1" style="width:100%">收货地址：{{printlists.address}}</li> 
				  </ul>
			      
			        <TABLE border=1 cellSpacing=0 cellPadding=1 width="100%" style="border-collapse:collapse;font-size:15px" bordercolor="#333333">
			 			<TR class="contactcontent">
			              <TD v-if="printsmodel.number==1"><DIV align=center><b>编号</b></DIV></TD>
			              <TD  v-if="printsmodel.product_name==1"><DIV align=center><b>品名</b></DIV></TD>
			              <TD  v-if="printsmodel.product_spec==1"><DIV align=center><b>规格</b></DIV></TD>
			              <TD v-if="printsmodel.unit==1"><DIV align=center><b>单位</b></DIV></TD>
			              <TD v-if="printsmodel.num==1"><DIV align=center><b>数量</b></DIV></TD>
			              <TD v-if="printsmodel.sell==1"><DIV align=center><b>售价</b></DIV></TD>
			              <TD v-if="printsmodel.discount==1"><DIV align=center><b>折扣</b></DIV></TD>
			              <TD v-if="printsmodel.dis_sell==1"><DIV align=center><b>折后单价</b></DIV></TD>
			              <TD v-if="printsmodel.market==1"><DIV align=center><b>零售价</b></DIV></TD>  
			              <TD v-if="printsmodel.account==1"><DIV align=center><b>小计</b></DIV></TD>
			              <TD v-if="printsmodel.warehourse==1"><DIV align=center><b>仓库</b></DIV></TD>
			              <TD v-if="printsmodel.desc==1"><DIV align=center><b>备注</b></DIV></TD>
			              <TD v-if="printsmodel.type==1"><DIV align=center><b>类型</b></DIV></TD>
			            </TR>
			 			  
			            <tr v-for="(item,index) in printlists.goods" :key="index" class="contactcontent" v-if="index >= prollpage[i]['startpage'] && index <= prollpage[i]['endpage'] ">
			              <TD v-text="item.number" align="center" v-if="printsmodel.number==1"></TD>
			              <TD v-text="item.name" style="padding-left:1%" v-if="printsmodel.product_name==1"></TD>
			              <TD v-text="item.spec" style="padding-left:1%" v-if="printsmodel.product_spec==1"></TD>
			              <TD v-text="item.unit" align="center" v-if="printsmodel.unit==1"></TD>
			              <TD v-text="item.num" align="center" v-if="printsmodel.num==1"></TD>
			              <TD v-text="item.sell" align="center" v-if="printsmodel.sell==1"></TD>
			              <TD v-text="item.discount" align="center" v-if="printsmodel.discount==1"></TD>
			              <TD v-text="item.dis_sell" align="center" v-if="printsmodel.dis_sell==1"></TD>
			              <TD v-text="item.market" align="center" v-if="printsmodel.market==1"></TD>
			              <TD v-text="item.total" align="center" v-if="printsmodel.account==1"></TD>
			              <TD v-text="item.warehouse" align="center" v-if="printsmodel.warehourse==1"></TD>
			              <TD v-text="item.note" style="padding-left:1%" v-if="printsmodel.desc==1"></TD>
			              <TD v-text="item.type" align="center" v-if="printsmodel.type==1"></TD>
			            </tr>
			            <tr v-if="iit.id==allprintpage">
			              <TD align="center" v-if="printsmodel.number==1 || printsmodel.product_name==1"><b>合计</b></TD>
			              <TD v-if="printsmodel.number==1 && printsmodel.product_name==1"></TD>
			              <TD v-if="printsmodel.product_spec==1"></TD>
			              <TD v-if="printsmodel.unit==1">&nbsp;</TD>
			              <TD v-if="printsmodel.num==1">&nbsp;</TD>
			              <TD v-if="printsmodel.sell==1">&nbsp;</TD>
			              <TD v-if="printsmodel.discount==1">&nbsp;</TD>
			              <TD v-if="printsmodel.dis_sell==1">&nbsp;</TD>
			              <TD v-if="printsmodel.market==1">&nbsp;</TD>
			              <TD align="center" v-if="printsmodel.account==1">{{printlists.amount}}</TD>
			              <TD v-if="printsmodel.warehourse==1">&nbsp;</TD>
			              <TD v-if="printsmodel.desc==1">&nbsp;</TD>
			              <TD v-if="printsmodel.type==1">&nbsp;</TD>
			            </tr>
			      </table>
			      <TABLE border=0 cellSpacing=0 cellPadding=0 width="100%">
			        <TBODY>
			        <TR class="top1">
			          <TD v-if="printsmodel.inputdate==1"><span>录单日期：{{printlists.inputtime}}</span></TD>
			          <TD v-if="printlists.express > 0"><span>快递费用：{{printlists.express}} 元</span></TD>
			          <TD v-if="printsmodel.derate==1"><span>优惠金额：{{printlists.derate}} 元</span></TD>
			          <TD v-if="printsmodel.total==1"><span>应付金额：{{printlists.real}} 元</span></TD>
			          <TD v-if="printsmodel.sysmanagername==1"><span>操作人：{{printlists.sysmanager}}</span></TD>
			        </tr>
			        <TR class="top1" v-if="printsmodel.print==1"">
			          <TD :colspan="4"><span>{{printsmodel.printvalue}}</span></TD>
			        </tr>
			        <TR class="top2">
			          <TD><span v-if="printsmodel.p_man==1">配货人</span></TD>
			          <TD><span v-if="printsmodel.s_man==1">送货人</span></TD>
			          <TD><span v-if="printsmodel.ss_man==1">收货人</span></TD>
			          <TD>&nbsp;</TD>
			          <TD>&nbsp;</TD>
			        </tr>
			        </TBODY>
			      </TABLE>
			      <div class="pageBreak"></div>
				  </div>
			  </div>
			  
		      <div slot="footer" class="dialog-footer">
		        <el-button @click="printerDialog = false">取 消</el-button>
		        <el-button type="primary" @click="createnoSave">出库不打印</el-button>
		        <el-button type="danger" @click="createSave">出库打印</el-button>
		      </div>
		  </el-dialog>
		  <!--------------------------------打印信息 end--------------------------->
		  
		  
		  <!---------------------------批量添加--------------------------->
		  <el-dialog title="添加产品" :visible.sync="addDialog" width="75%" top="1vh">
		  	  <el-tag type="danger">温馨提示：如需设置选择默认仓库，请前往系统设置->用户管理，编辑具体用户信息选择默认发货仓库</el-tag>
		      <!------------------------search---------------------->
		        <el-form :inline="true" class="demo-form-inline" style="margin-top:15px">
		          <el-form-item style="width:15%;">
		            <el-select v-model="productquery.brandid" filterable placeholder="按品牌"  @change="selectbrand">
		              <el-option label="不分品牌" value="0"></el-option>
		              <el-option v-for="(item,index) in brandlists" :label="item.name" :value="item.brandid" :key="index"></el-option>
		            </el-select>
		          </el-form-item>
		          <el-form-item style="width:15%">
		              <el-cascader :options="categorylist" v-model="productquery.catid" placeholder="请选择分类" @change="selectcate"></el-cascader>
		          </el-form-item>
		          <el-form-item style="width:15%;">
		            <el-select v-model="productquery.warehouse" placeholder="请选择仓库" @change="selectwarehouse">
		              <el-option label="全部仓库" value="0"></el-option>
		              <el-option v-for="(item,index) in wareAllLists" :label="item.name" :value="item.id" :key="index"></el-option>
		            </el-select>
		          </el-form-item>
		          <el-form-item ref="productquery" :model="productquery">
		            <el-input placeholder="商品名称 / 条形码 / 编号 / 拼音码" size="25" v-model="productquery.key" @keyup.enter.native="getProductList" @change="isnewselect=true"></el-input>
		          </el-form-item>
		          <el-form-item>
		            <el-button type="primary" icon="el-icon-search" @click="getProductList">查询</el-button>
		          </el-form-item>
		        </el-form>
		      <!------------------------search end---------------------->
		      <el-table ref="multipleTable" :data="productlists" style="width: 100%" v-loading="addListLoading" tooltip-effect="dark" @row-click="selectrow" @select="handleSelectsingle"  @select-all="handleSelectall"  >
		          <el-table-column type="selection" width="40"></el-table-column>
		          <el-table-column prop="number" label="编号" width="80"></el-table-column>
		          <el-table-column prop="brandname" label="品牌名称" width="100"></el-table-column>
		          <el-table-column prop="name" label="名称"></el-table-column>
		          <el-table-column prop="spec" label="规格" width="120"></el-table-column>
		          <el-table-column prop="housename" label="仓库" width="120"></el-table-column>
		          <el-table-column prop="showsell" label="售价" width="140"></el-table-column>
		          <el-table-column label="库存" width="110">
		          	  <template slot-scope="scope">
		          	  	  <span v-if="scope.row.inventory==0" style="color:#F56C6C">{{scope.row.inventory}}</span>
		          	  	  <span v-if="scope.row.inventory>0">{{scope.row.inventory}}</span>
		          	  </template>
		          </el-table-column>
		      </el-table>
		      <div class="block">
		          <!--分页begin-->
		          <el-pagination
		            @size-change="productPageSizeChange"
		            @current-change="productPageCurrentChange"
		            :current-page="productquery.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="productquery.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="total_product_rows">
		          </el-pagination>
		          <!--分页end-->
		      </div>
		      <div slot="footer" class="dialog-footer">
		          <el-button @click="addDialog = false">取 消</el-button>
		          <el-button type="primary" :loading="addProductLoading" @click="addSave">确认添加</el-button>
		      </div>
		  </el-dialog>
		  <!--------------------------------批量添加end--------------------------->
		  
		  <!--------------------------------审核、发货订单信息--------------------------->
          <el-dialog title="审核/发货订单信息" :visible.sync="verifyandsendDialog" width="75%" top="10vh">
          	  <div class="orderinfos dialog-footer">
          	    <span>客户名称：{{orders.customername}}</span>
          	    <span>交货日期：{{orders.deliverdate}}</span>
          	    <span>收货人姓名：{{orders.contact}}</span>
          	    <span>单据编号：{{orders.ordernum}}</span>
          	    <span>出库备注：{{orders.note}}</span>
          	    <span>收货人电话：{{orders.phone}}</span>
          	    <span>支付方式：{{orders.accountname}}</span>
          	    <span style="width:66.66%">收货人地址：{{orders.address}}</span>
          	  </div>
          	  
          	  <el-table :data="orders.goods" style="width:100%" border v-loading="vosLoading" tooltip-effect="dark">
		          <el-table-column prop="name" label="品名"></el-table-column>
		          <el-table-column prop="spec" label="规格" width="75" align="center"></el-table-column>
		          <el-table-column prop="unit" label="单位" width="75" align="center"></el-table-column>
		          <el-table-column prop="num" label="数量" width="70" align="center"></el-table-column>
		          <el-table-column prop="sell" label="售价" width="70" align="center"></el-table-column>
		          <el-table-column prop="discount" label="折扣" width="70" align="center"></el-table-column>
		          <el-table-column prop="dis_sell" label="折后单价" width="80" align="center"></el-table-column>
		          <el-table-column prop="total" label="小计" width="80" align="center"></el-table-column>
		          <el-table-column prop="warehousename" label="仓库" width="90" align="center"></el-table-column>
		          <el-table-column prop="type" label="类型" width="80" align="center"></el-table-column>
		      </el-table>
		      
		      <div class="orderinfos dialog-footer">
		        <span>订单合计：{{orders.total}}</span>
          	    <span>优惠金额：{{orders.derate}}</span>
          	    <span>应付金额：{{orders.real}}</span>
          	    <span v-if="orders.express > 0">快递费用：{{orders.express}}</span>
          	    <span>录单日期：{{orders.inputtime}}</span>
          	    <span>操作人：{{orders.sysmanagername}}</span>
          	  </div>
          	  <div slot="footer" class="dialog-footer" style="margin-bottom:40px"></div>	  
          </el-dialog>
        

    </div>
</template>

<script>

export default {
  data () {
      return {
	      url:this.GLOBAL.domain+"Pdorder/index",
	      
	      /** 列表相关信息 **/
	      customerLoading:false,
	      customerLists:[],
	      sellerLists:[],
	      lists:[],
	      listLoading:false,
	      total_rows:0,
	      query: {
	      	  act:'lists',
	      	  customer:'',
	      	  clerkid:'',
	      	  status:'',
	      	  date:[],
	      	  key:'',
	          token:this.$cookies.get('token'),
	          rollpage: 10, // 页大小
	          p: 1,
	      },
	      statuslists:[
	      		{id:'0',name:'全部'},
	      		{id:'4',name:'待审核'},
	      		{id:'1',name:'已审核，待发货'},
	      		{id:'2',name:'已发货，待签收'},
	      		{id:'5',name:'已签收，待确认'},
	      		{id:'6',name:'已完成'},
	      		{id:'3',name:'已取消'}
	      ],
	      
	      /** 审核相关 **/
	      changeStatusDialog:false,
	      saveverifyloading:false,
	      verify:{
	      	  id:'',
	      	  status:'',
	      	  ordernum:'',
	      },
	      verifylists:[
	      	  {id:'1',name:'通过审核，等待发货'},
	      	  {id:'2',name:'取消订单'}
	      ],
	      sendnumber:0,
	      
	      /** 待发货信息相关 **/
	      sendDialog:false,
	      sendlistLoading:false,
	      sendlists:[],
	      send_row_number:0,
	      sendquery: {
	      	  act:'getsendlists',
	      	  customer:'',
	      	  clerkid:'',
	      	  status:'',
	      	  date:[],
	      	  key:'',
	          token:this.$cookies.get('token'),
	          rollpage: 10, // 页大小
	          p: 1,
	      },
	      sendstatuslists:[
	      	  {id:'0',name:'全部'},
	      	  {id:'1',name:'待发货'},
	      	  {id:'2',name:'已发货'},
	      ],
	      
	      /** 改单相关 **/
	      editparam:{
	      	  id:'',
	      	  real:'',
	      	  derate:'',
	      	  amount:'',
	      	  deliverdate:'',
	      	  documents:'',
	      	  account:'',
	      	  seller:'',
	      	  sysmanager:'',
	      	  shipping:'',
	      	  shippingcode:'',
	      	  express:0.00,
	      	  note:'',
	      	  goods:[],
	      },
	      
	      oid:'',
	      unitlists:[],
	      warehouselists:[],
	      editorderlists:[],
	      accountLists:[],
	      sysmanagers:[],
	      printsmodel:[],
	      printlists:[],
	      typearr:[
	      	{name:'消费'},
	      	{name:'赠送'},
	      	{name:'自用'},
	      	{name:'报废'},
	      	{name:'欠货'}
	      ],
	      shippings:[
	      	{id:'1',name:'线下配送'},
	      	{id:'2',name:'物流'},
	      	{id:'3',name:'快递'},
	      	{id:'4',name:'自提'}
	      ],
	      editorderDialog:false,
	      editgoodsLoading:false,
	      saveeditloading:false,
	      unitlistsDialog:false,
	      unitListLoading:false,
	      warehouseDialog:false,
      	  warehouseListLoading:false,
      	  typeDialog:false,
      	  typeListLoading:false,
      	  printerDialog:false,
      	  
      	  /** 添加商品信息相关 **/
      	  addDialog:false,
      	  wareAllLists:[],
      	  brandlists:[],
      	  isnewselect:false,
      	  addListLoading:false,
      	  multipleSelection:[],
      	  productlists:[],
      	  pclickstatus:[],
      	  productquery:{
      	  	  baseorderid:'',
      	  	  ordertype:'',
      	  	  oid:'',
	          act:'inventory',
	          token:this.$cookies.get('token'),
	          brandid:'',
	          catid:'',
	          warehouse:'',
	          key:'',
	          rollpage: 10, // 页大小
	          p: 1
          },
      	  categorylist:[],
      	  isopenselect:false, //是否开启点击单行自动选择
      	  addProductLoading:false,
      	  
      	  prpage:[],
		  prollpage:[],
		  prtotal:0,
		  rollpage:'',
		  allprintpage:'',
      	  defaultwarehouseid:'', //默认发货仓库
      	  orderinfos:[],
      	  verifyandsendDialog:false,
      	  orders:[],
      	  vosLoading:false,
      	  actionauth:[], //会员操作级权限
      }
  },
  
  
  mounted(){
  	  this.getactionauth(); //获取功能权限
  	  this.getList(); //获取订单列表
  	  this.getSeller(); //获取销售员信息
  	  this.getAccount(); //获取支付方式信息
  	  this.getSysmanager(); //获取操作人列表
  	  this.getprintsmodel(); //获取打印设置
  	  
  	  this.getWarehouse(); //获取仓库信息列表
      this.getBrand(); //获取品牌信息列表
      this.getCategoryList(); //获取商品分类
      this.getdefaultwarehouse(); //获取默认发货仓库
  },
  
  
  methods:{
  
  	  //获取功能权限
	  getactionauth() {
	      var data =this.$cookies.get('actionauth');
	      data=JSON.parse(data);
	      this.actionauth=data;
	  },
	  
	  /** 获取跑店下单原始订单列表 **/
	  getList() {
	  	  this.listLoading = true;
      	  var resource = this.$resource(this.url);
      	  resource.query(this.query).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          	  this.listLoading = false;
	          }else{
	          	  this.lists = JSON.parse(Base64.decode(res.data.Data));
	          	  this.total_rows=parseInt(res.data.count);
	          	  this.listLoading = false;
	          }
     	  }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	          this.listLoading=false;
      	  });
      },
	  
	  pageSizeChange(val) {
          this.query.rollpage = val;
          this.getList();
      },
      pageCurrentChange(val) {
          this.query.p = val;
          this.getList();
      },
      
      
      /** 获取仓库 **/
      getWarehouse(){
          var resource = this.$resource(this.GLOBAL.domain+"Ware/index");
          resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	          }else{
	              this.wareAllLists = JSON.parse(Base64.decode(res.data.Data));
	          }
          }).catch((res) => {
              //this.$message.error(this.GLOBAL.errortext);
          });
      },
      
      
      /** 获取品牌 **/
      getBrand(){
          var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
          resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	          }else{
	              this.brandlists = JSON.parse(Base64.decode(res.data.Data));
	          }
          }).catch((res) => {
              //this.$message.error(this.GLOBAL.errortext);
          });
      },
      
       
     /** 获取产品分类 **/
     getCategoryList() {
    	  var resource = this.$resource(this.GLOBAL.domain+"Product/index");
          resource.query({ act:'getcatelist',token:this.$cookies.get('token')}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	          }else{
	              this.categorylist=JSON.parse(Base64.decode(res.data.Data));
	          }
          }).catch((res) => {
              //this.$message.error(this.GLOBAL.errortext);
          });
     },
      
      
      
      /** 获取客户 **/
      getCustomer(query){
          if (query !== '') {
	          this.customerLoading = true;
	          var resource = this.$resource(this.GLOBAL.domain+"Customer/index");
	          resource.query({act:'lists',key:query,token:this.$cookies.get('token')}).then((res) => {
	              if(res.data.Result>0){
		              if(res.data.Result=='70001') this.$router.push('/login')
		              this.$message.error(res.data.Message);
		              this.customerLoading = false;
	              }else{
		              this.customerLists = JSON.parse(Base64.decode(res.data.Data));
		              this.customerLoading = false;
	              }
	          }).catch((res) => {
	              //this.$message.error(this.GLOBAL.errortext);
	              this.customerLoading = false;
	          });
          }
      },
      
      /** 获取销售员 **/
      getSeller(){
	      var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
	      resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          }else{
	          	  this.sellerLists = JSON.parse(Base64.decode(res.data.Data));
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	      });
      },
      
      
      /** 获取银行帐户 **/
      getAccount(){
          var resource = this.$resource(this.GLOBAL.domain+"Account/index");
          resource.query({act:'lists',isdeposit:1,isnopay:1,token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	          }else{
	              this.accountLists = JSON.parse(Base64.decode(res.data.Data));
	          }
          }).catch((res) => {
              //this.$message.error(this.GLOBAL.errortext);
          });
      },
      
      /** 获取经手人 **/
      getSysmanager() {
          var resource = this.$resource(this.GLOBAL.domain+"Manager/index");
          resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:10,p:1}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	          }else{
	              this.sysmanagers = JSON.parse(Base64.decode(res.data.Data));
	              this.create.sysmanager=this.$cookies.get('managerid');
	          }
          }).catch((res) => {
              //this.$message.error(this.GLOBAL.errortext);
          });
      },
      
      
      //////////////////////////////////////////////////////////////////////////////////////////////////      
      /** 确认审核订单 **/
      sureverify(item) {
          this.$confirm('您是否已经确认该订单信息已经审核过 ?', '提示', { type: 'warning' }).then(() => {          	  
          	  //修改订单状态
          	  var resource = this.$resource(this.url);
			  resource.query({act:'changestatusverify',id:item.id,token:this.$cookies.get('token')}).then((res) => {
			  	  if(res.data.Result>0){
			      	  if(res.data.Result=='70001') this.$router.push('/login')
			          this.$message.error(res.data.Message); 	
			      }else{
			          this.getList();
			      }
			  }).catch((res) => {
			  	  //this.$message.error(this.GLOBAL.errortext);
			  });
          	  
          }).catch(() => {
              this.$message.info('已取消操作!');
          });
      },
      
      
      /** 修改审核订单 **/
      editverify(item) {
      	  //修改订单状态
      	  this.editorderDialog=true;
          var resource = this.$resource(this.url);
          this.getdetailinfos(item.id);
      },
      
      
      /** 重新获取订单详情信息 **/
      getdetailinfos(id) {
      	  this.editgoodsLoading=true;
      	  var resource = this.$resource(this.url);
	      resource.query({act:'getDetail',id:id,token:this.$cookies.get('token')}).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          	  this.editgoodsLoading=false;
	          }else{
	          	  var result = JSON.parse(Base64.decode(res.data.Data));
	          	  var _this=this;
		      	  this.editparam.goods=[];
		      	  this.editparam.id=result.id;
		      	  this.editparam.amount=result.amount;
		      	  this.editparam.real=result.real;
		      	  this.editparam.derate=result.derate;
		      	  this.editparam.deliverdate=result.deliverdate;
		      	  this.editparam.documents=result.ordernum;
		      	  this.editparam.account=result.account;
		      	  this.editparam.seller=result.sellerid;
		      	  this.editparam.sysmanager=result.sysmanager;
		      	  this.editparam.shipping=result.shipping;
		      	  this.editparam.shippingcode=result.shippingcode;
		      	  this.editparam.express=result.express;
		      	  this.editparam.note=result.note;
		      	  this.editparam.customerid=result.customerid;
		      	  this.editparam.baseorderid=result.baseorderid;
		      	  this.editparam.ordertype=result.ordertype;
		      	  
		      	  result.goods.forEach(function(e,index) {
		      	  	  var param={oid:e.oid,productid:e.productid,productname:e.productname,spec:e.spec,unitid:e.unitid,unit:e.unit,num:e.num,sell:e.sell,discount:e.discount,dis_sell:e.dis_sell,total:e.total,warehouseid:e.warehouseid,warehousename:e.warehousename,type:e.type};
		      	  	  _this.editparam.goods.push(param);  	   	 	  	 	  	 	  	 	  	 	  	 	  	  
		      	  });
	          	  
	          	  this.editgoodsLoading=false;
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	          this.editgoodsLoading=false;
	      });
      },
      
    
      /** 取消订单 **/
      delCurrentorder(item) {
          this.$confirm('您是否确定要把订单编号为：'+item.ordernum+'的单子取消，继续?', '提示', { type: 'warning' }).then(() => {
			  var resource = this.$resource(this.url);
		      resource.query({act:'delorder',id:item.id,token:this.$cookies.get('token')}).then((res) => {
		          if(res.data.Result>0){
		          	  if(res.data.Result=='70001') this.$router.push('/login')
		          	  this.$message.error(res.data.Message);
		          	  this.getList(item.id);
		          }else{
		          	  this.$message.success('取消订单成功!');
		          	  this.getList(item.id);
		          }
		      }).catch((res) => {
		          this.$message.error(this.GLOBAL.errortext);
		          this.getList(item.id);
		      });
          }).catch(() => {
              this.$message.info('已取消操作!');
          });
      },
      
      
      /** 修改商品数量 **/
      changeNum(item,index) {
      	  this.editgoodsLoading=true;
      	  var param=[];		  
		  item.baseorderid=this.editparam.baseorderid;
		  item.ordertype=this.editparam.ordertype;
      	  item.act='changnum';
      	  item.token=this.$cookies.get('token');
      	  
      	  var resource = this.$resource(this.url);
	      resource.save(item).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          	  this.editgoodsLoading=false;
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }else{
	          	  this.editgoodsLoading=false;
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	          this.editgoodsLoading=false;
	      });
      },
      
      
      /** 获取单位信息列表 **/
      changeUnit(item) {      
      	  this.oid=item.oid;
      	  item.act='getunitlist';
      	  item.token=this.$cookies.get('token');
      	  this.unitlistsDialog=true;
      	  this.unitListLoading=true;
      	  
      	  var resource = this.$resource(this.url);
	      resource.save(item).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          	  this.unitListLoading=false;
	          }else{
	          	  this.unitlists=JSON.parse(Base64.decode(res.data.Data));
	          	  this.unitListLoading=false;
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	          this.unitListLoading=false;
	      });
      },
      
      
      /** 保存修改的单位信息 **/
      changeUnitSave(item) {
      	  item.baseorderid=this.editparam.baseorderid;
		  item.ordertype=this.editparam.ordertype;
      	  item.oid=this.oid;
      	  item.act='saveunitlist';
      	  item.token=this.$cookies.get('token');
      	  
      	  var resource = this.$resource(this.url);
	      resource.save(item).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          	  this.unitlistsDialog=false;
	          }else{
	          	  this.unitlistsDialog=false;
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	          this.unitlistsDialog=false;
	      });
      	  
      },
      
      
      /** 修改商品售价信息 **/
      changeSell(item) {
      	  item.baseorderid=this.editparam.baseorderid;
		  item.ordertype=this.editparam.ordertype;
      	  this.editgoodsLoading=true;
      	  item.act='changesell';
      	  item.token=this.$cookies.get('token');
      	  
      	  var resource = this.$resource(this.url);
	      resource.save(item).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          	  this.editgoodsLoading=false;
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }else{
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          	  this.editgoodsLoading=false;
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	          this.editgoodsLoading=false;
	      });
      },
      
      
      /** 修改商品折扣 **/
      changeDiscount(item) {
      	  this.editgoodsLoading=true;
		  item.baseorderid=this.editparam.baseorderid;
		  item.ordertype=this.editparam.ordertype;
      	  item.act='changediscount';
      	  item.token=this.$cookies.get('token');
      	  
      	  var resource = this.$resource(this.url);
	      resource.save(item).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          	  this.editgoodsLoading=false;
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }else{
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          	  this.editgoodsLoading=false;
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	          this.editgoodsLoading=false;
	      });
      },
      
      
      /** 修改折后单价 **/
      changeDissell(item) {
      	  this.editgoodsLoading=true;
      	  item.baseorderid=this.editparam.baseorderid;
		  item.ordertype=this.editparam.ordertype;
      	  item.act='changedissell';
      	  item.token=this.$cookies.get('token');
      	  
      	  var resource = this.$resource(this.url);
	      resource.save(item).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          	  this.editgoodsLoading=false;
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }else{
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          	  this.editgoodsLoading=false;
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	          this.editgoodsLoading=false;
	      });
      },
      
      
      /** 修改小计 **/
      changeTotal(item) {
      	  this.editgoodsLoading=true;
		  item.baseorderid=this.editparam.baseorderid;
		  item.ordertype=this.editparam.ordertype;
      	  item.act='changetotal';
      	  item.token=this.$cookies.get('token');
      	  
      	  var resource = this.$resource(this.url);
	      resource.save(item).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          	  this.editgoodsLoading=false;
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }else{
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          	  this.editgoodsLoading=false;
	          }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	          this.editgoodsLoading=false;
	      });
      },
      
      
      /** 获取商品仓库信息 **/
      changeWarehouse(item) {
      	  item.baseorderid=this.editparam.baseorderid;
		  item.ordertype=this.editparam.ordertype;
      	  this.oid=item.oid;
      	  item.act='getwarehouselists';
      	  item.token=this.$cookies.get('token');
      	  this.warehouseDialog=true;
      	  this.warehouseListLoading=true;
      	  
      	  var resource = this.$resource(this.url);
	      resource.save(item).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          	  this.warehouseListLoading=false;
	          }else{
	          	  this.warehouselists=JSON.parse(Base64.decode(res.data.Data));
	          	  this.warehouseListLoading=false;
	          }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	          this.warehouseListLoading=false;
	      });
      },
      
      
      /** 保存修改的库存信息 **/
      changeWareSave(item) {
      	  item.baseorderid=this.editparam.baseorderid;
		  item.ordertype=this.editparam.ordertype;
      	  item.oid=this.oid;
      	  item.act='savewarehouse';
      	  item.token=this.$cookies.get('token');
      	  
      	  var resource = this.$resource(this.url);
	      resource.save(item).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          }else{
	          	  this.warehouseDialog=false;
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	      });
      },
      
      
      /** 获取商品类型列表 **/
      changeType(item) {
      	  this.oid=item.oid;
      	  //获取商品类型列表
      	  this.typeDialog=true;
      },
      
      
      /** 保存商品类型信息 **/
      changeTypeSave(item) {
      	  item.baseorderid=this.editparam.baseorderid;
		  item.ordertype=this.editparam.ordertype;
      	  item.oid=this.oid;
      	  item.act='savetype';
      	  item.token=this.$cookies.get('token');
      	  
      	  var resource = this.$resource(this.url);
	      resource.save(item).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          }else{
	          	  this.typeDialog=false;
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	      });
      },
      
      
      /** 修改实收金额 **/
      changeReal() {
      	  var param={act:'changereal',token:this.$cookies.get('token'),id:this.editparam.id,real:this.editparam.real,baseorderid:this.editparam.baseorderid,ordertype:this.editparam.ordertype};      	      	  
      	  var resource = this.$resource(this.url);
	      resource.save(param).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }else{
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	      });
      },
      
      
      /** 修改优惠金额 **/
      changeDerate() {
      	  var param={act:'changederate',token:this.$cookies.get('token'),id:this.editparam.id,derate:this.editparam.derate,amount:this.editparam.amount,baseorderid:this.editparam.baseorderid,ordertype:this.editparam.ordertype};      	  
      	        	  
      	  var resource = this.$resource(this.url);
	      resource.save(param).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }else{
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	      });
      },
      
      
      /** 编辑交货日期 **/
      changedeliverdate() {
      	  var param={act:'changedeliverdate',token:this.$cookies.get('token'),id:this.editparam.id,deliverdate:this.editparam.deliverdate,baseorderid:this.editparam.baseorderid,ordertype:this.editparam.ordertype};      	     	  
      	  var resource = this.$resource(this.url);
	      resource.save(param).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }else{
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	      });
      },
      
      
      /** 编辑付款方式 **/
      changeaccount() {
      	  var param={act:'changeaccount',token:this.$cookies.get('token'),id:this.editparam.id,account:this.editparam.account,baseorderid:this.editparam.baseorderid,ordertype:this.editparam.ordertype};      	  
      	        	  
      	  var resource = this.$resource(this.url);
	      resource.save(param).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }else{
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	      });
      },
      
      
      /** 编辑销售员 **/
      changeseller() {
      	  var param={act:'changeseller',token:this.$cookies.get('token'),id:this.editparam.id,seller:this.editparam.seller,baseorderid:this.editparam.baseorderid,ordertype:this.editparam.ordertype};      	  
      	        	  
      	  var resource = this.$resource(this.url);
	      resource.save(param).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }else{
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	      });
      },
      
      
      /** 编辑操作员 **/
      changesysmanager() {
      	  var param={act:'changesysmanager',token:this.$cookies.get('token'),id:this.editparam.id,sysmanager:this.editparam.sysmanager,baseorderid:this.editparam.baseorderid,ordertype:this.editparam.ordertype};      	  
      	        	  
      	  var resource = this.$resource(this.url);
	      resource.save(param).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }else{
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	      });
      },
      
      
      /** 编辑配送方式 **/
      changeshipping() {
      	  var param={act:'changeshipping',token:this.$cookies.get('token'),id:this.editparam.id,shipping:this.editparam.shipping,baseorderid:this.editparam.baseorderid,ordertype:this.editparam.ordertype};      	  
      	        	  
      	  var resource = this.$resource(this.url);
	      resource.save(param).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }else{
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	      });
      },
      
      
      /** 编辑物流单号 **/
      changeshippingcode() {
      	  var param={act:'changeshippingcode',token:this.$cookies.get('token'),id:this.editparam.id,shippingcode:this.editparam.shippingcode,baseorderid:this.editparam.baseorderid,ordertype:this.editparam.ordertype};      	  
      	        	  
      	  var resource = this.$resource(this.url);
	      resource.save(param).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }else{
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	      });
      },
      
      
      /** 编辑快递费用 **/
      changeexpress() {
      	  var param={act:'changeexpress',token:this.$cookies.get('token'),id:this.editparam.id,express:this.editparam.express,baseorderid:this.editparam.baseorderid,ordertype:this.editparam.ordertype};      	  
      	        	  
      	  var resource = this.$resource(this.url);
	      resource.save(param).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }else{
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	      });
      },
      
      
      /** 编辑备注 **/
      changenode() {
      	  var param={act:'changenode',token:this.$cookies.get('token'),id:this.editparam.id,note:this.editparam.note,baseorderid:this.editparam.baseorderid,ordertype:this.editparam.ordertype};      	  
      	        	  
      	  var resource = this.$resource(this.url);
	      resource.save(param).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }else{
	          	  this.getdetailinfos(this.editparam.baseorderid);
	          }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	      });
      },
      
      
      /** 删除待发货商品信息 **/
      delCurrent(item) {
      	  this.$confirm('您是否确定要删除该商品，继续?', '提示', { type: 'warning' }).then(() => {
			item.baseorderid=this.editparam.baseorderid;
			item.ordertype=this.editparam.ordertype;
      	  	item.act='delcurrent';
      	    item.token=this.$cookies.get('token');
      	  
        	// 向请求服务端删除
        	this.editgoodsLoading=true;
            var resource = this.$resource(this.url);
            resource.save(item).then((res) => {
            	if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                    this.editgoodsLoading=false;
                    this.getdetailinfos(this.editparam.baseorderid);
                }else{
                    this.$message.success('删除商品成功!');  
                    this.editgoodsLoading=false;                  
                    this.getdetailinfos(this.editparam.baseorderid);
                }
            }).catch((res) => {
            	//this.$message.error(this.GLOBAL.errortext);
            	this.editgoodsLoading=false;
            });
          }).catch(() => {
              this.$message.info('已取消操作!');
          });
      },      
      
      
      /** 保存修改的订单信息 **/
      saveedit() {      
      	  this.saveeditloading=true;
      	  var resource = this.$resource(this.url);
	      resource.query({act:'ensure',token:this.$cookies.get('token'),id:this.editparam.id}).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          	  this.saveeditloading=false;
	          }else{
	          	  this.printlists=JSON.parse(Base64.decode(res.data.Data));
				  this.saveeditloading=false;
				  this.printerDialog=true;
				  //设置打印分页显示信息
	      		  this.changepage();
	          }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	          this.saveeditloading=false;
	      });
      },
      
      
      /** 出库不打印 **/
      createnoSave() {
      	  var resource = this.$resource(this.url);
	      resource.query({act:'addorder',token:this.$cookies.get('token'),id:this.editparam.id}).then((res) => {
	          if(res.data.Result>0){
	          	  if(res.data.Result=='70001') this.$router.push('/login')
	          	  this.$message.error(res.data.Message);
	          }else{
	          	  this.$message.success('出库成功！');
	          	  this.printerDialog=false;
				  this.editorderDialog=false;
				  this.getList();
	          }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	      });
      },
      
      
      /** 出库并打印 **/
      createSave() {
      	  this.createnoSave();
      	  //设置打印完成后回调页面
    	  this.$cookies.set('returnurlids','1,101');
    	  //设置打印信息
      	  var div_print=document.getElementById('printContent');
	      var newStr=div_print.innerHTML;
	      var oldStr=document.body.innerHTML;
	      document.body.innerHTML=newStr;
	      window.print();
	      document.body.innerHTML=oldStr;
	      location.reload();
      },
      
      
      /** 获取打印模板设置 **/
      getprintsmodel() {
    	var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
        resource.query({ act:'getmodelsetting',id:1,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.printsmodel=JSON.parse(Base64.decode(res.data.Data));
	            this.rollpage=this.printsmodel.pagevalue < 1 ? 10 : this.printsmodel.pagevalue
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
      },
      
      
      /** 添加商品 **/
      addmoregoods() {
      	  this.productquery.brandid='';
    	  this.productquery.catid=[];
    	  this.productquery.key='';
    	  this.productquery.warehouse=this.defaultwarehouseid==0 ? '' : this.defaultwarehouseid;
    	  this.productquery.p=1;
    	  this.productquery.rollpage=10; 
      	  this.addDialog=true;
          this.getProductList();
      },
      
      
      /** 获取商品信息列表 **/
      getProductList(){
      	  this.productquery.oid=this.editparam.id;
      	  this.productquery.baseorderid=this.editparam.baseorderid;
      	  this.productquery.ordertype=this.editparam.ordertype;
    	  if(this.isnewselect==true) {
			  this.productquery.p=1;
			  this.productquery.rollpage=10;	    	
    	  }
    	
    	  this.isopenselect=false; //关闭点击单行自动添加数据
    
    	  var _this=this;
          this.addListLoading = true;
          this.multipleSelection=[];
          var resource = this.$resource(this.url);
          resource.query(this.productquery).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	              this.addListLoading = false;
	          }else{
	              this.productlists = JSON.parse(Base64.decode(res.data.Data));
	              this.total_product_rows=parseInt(res.data.count);
	            
	              this.pclickstatus=[];
	              this.productlists.forEach(function() {
	            	  _this.pclickstatus.push(0);
	              });	            
	              this.addListLoading = false;
	          }
	        
	          if(this.isnewselect==true) this.isnewselect=false;
          }).catch((res) => {
              //this.$message.error(this.GLOBAL.errortext);
              this.addListLoading=false;
              if(this.isnewselect==true) this.isnewselect=false;
          });
      },
      productPageSizeChange(val) {
          this.productquery.rollpage = val;
          this.getProductList();
      },
      productPageCurrentChange(val) {
          this.productquery.p = val;
          this.getProductList();
      },
      
      /** 品牌搜索（品牌发生变化时触发一次搜索） **/
      selectbrand() {
    	  this.isnewselect=true;
    	  this.getProductList();
      },
      /** 分类搜索（分类发生变化触发一次搜索） **/
      selectcate() {
    	  this.isnewselect=true;
    	  this.getProductList();
      },
      /** 仓库搜索（仓库发生变化触发一次搜索） **/
      selectwarehouse() {
    	  this.isnewselect=true;
    	  this.getProductList();
      },
      
      
      
      /** 点击单行触发事件 **/
      selectrow(row,event,column) {      
    	  var id=row.id;
    	  var number=0;
    	  var isselect=0;
    	  var _this=this;
    	
    	  //获取当前商品在商品列表里的位置
    	  this.productlists.forEach(function(e,index) {if(id==e.id) number=index;});
    	
    	  //给该位置进行勾选或取消勾选
    	  if(this.pclickstatus[number]==0) {
    		  this.pclickstatus[number]=1;
    	  }else {
    		  this.pclickstatus[number]=0;
    	  }
		
		  //判断该商品在选取列表里是否存在，存在则删除该商品，不存在则添加该商品
		  this.$refs.multipleTable.toggleRowSelection(this.productlists[number]);
		  this.multipleSelection.forEach(function(e,index) {
			  if(id==e.id) isselect=1;
		  });
		
		  if(isselect==1) {
			  this.multipleSelection.forEach(function(e,index) {
				  if(id==e.id) _this.multipleSelection.splice(index,1);
			  });
		  }else {	
			  this.multipleSelection.push(row);
							
			  //异步判断添加的商品是否满足添加的要求（判断商品库存）
	    	  var resource = _this.$resource(_this.url);
	    	  resource.save({act:'checkinventorys',product:row,id:this.productquery.oid,token:this.$cookies.get('token')}).then((res) => {
		    	  if(res.data.Result>0){
			    	  if(res.data.Result=='70001') this.$router.push('/login');
			          this.$message.error(res.data.Message);
		          }else{
		              var data=Base64.decode(res.data.Data);
		              if(data==2) { //库存不足时提示欠货处理
		            	  this.$confirm(row.name+'库存不足，出库时将作为欠货商品处理，您是否要添加该商品', '提示', { type: 'warning' }).then(() => {
		        			  //确认添加按原来的方式，此处不做任何处理
				          }).catch(() => {
				       		  //取消操作时，取消勾选的商品
				       		  this.$refs.multipleTable.toggleRowSelection(this.productlists[number]);
				       		  //勾选的商品列表里剔除该商品
				       		  this.multipleSelection.forEach(function(e,index) {
								  if(id==e.id) _this.multipleSelection.splice(index,1);
							  });
							  //修改该商品是否勾选的状态
							  this.pclickstatus[number]=0;
				       		
				          });
		              }
		          }
		      }).catch((res) => {
		        	
		      });
		  }
      },
      
      
      /** 点击每行前面的选择框勾选/取消勾选商品 **/
      handleSelectsingle(val,row) {    	
    	  var id=row.id;
    	  var number=0;
    	  var isselect=0;
    	  var _this=this;
    	
    	  //获取当前商品在商品列表里的位置
    	  this.productlists.forEach(function(e,index) {if(id==e.id) number=index;});
    	
    	  //给该位置进行勾选或取消勾选
    	  if(this.pclickstatus[number]==0) {
    		  this.pclickstatus[number]=1;
    	  }else {
    		  this.pclickstatus[number]=0;
    	  }
		
		  //判断该商品在选取列表里是否存在，存在则删除该商品，不存在则添加该商品
		  this.multipleSelection.forEach(function(e,index) {if(id==e.id) isselect=1;});
    	  if(isselect==1) {
			  this.multipleSelection.forEach(function(e,index) {
				  if(id==e.id) _this.multipleSelection.splice(index,1);
			  });
		  }else {	
			  this.multipleSelection.push(row);
							
			  //异步判断添加的商品是否满足添加的要求（判断商品库存）
	    	  var resource = _this.$resource(_this.url);
	    	  resource.save({act:'checkinventorys',product:row,id:this.productquery.oid,token:this.$cookies.get('token')}).then((res) => {
		    	  if(res.data.Result>0){
			    	  if(res.data.Result=='70001') this.$router.push('/login');
			          this.$message.error(res.data.Message);
		          }else{
		              var data=Base64.decode(res.data.Data);
		              if(data==2) { //库存不足时提示欠货处理
		            	  this.$confirm(row.name+'库存不足，出库时将作为欠货商品处理，您是否要添加该商品', '提示', { type: 'warning' }).then(() => {
		        			  //确认添加按原来的方式，此处不做任何处理
				          }).catch(() => {
				       		  //取消操作时，取消勾选的商品
				       		  this.$refs.multipleTable.toggleRowSelection(this.productlists[number]);
				       		  //勾选的商品列表里剔除该商品
				       		  this.multipleSelection.forEach(function(e,index) {
								  if(id==e.id) _this.multipleSelection.splice(index,1);
							  });
							  //修改该商品是否勾选的状态
							  this.pclickstatus[number]=0;
				       		
				          });
		              }
		          }
		      }).catch((res) => {
		        	
		      });
		  }
      },
      
      
      /** 点击选全部可见商品 **/
      handleSelectall(val) {   	
    	  this.isopenselect=false; //关闭点击单行添加数据
    	  var _this=this;
    	  var number=0;
    	  if(val=='') return false;
    	  this.multipleSelection=[];
    	
    	  val.forEach(function(e,index) {	
    		  _this.productlists.forEach(function(obj,i) {
    			  if(e.id==obj.id) {
    				  //异步判断添加的商品是否满足添加的要求（主要判断商品库存）
				      var resource = _this.$resource(_this.url);
				      resource.save({act:'checkinventorys',product:e,id:_this.productquery.oid,token:_this.$cookies.get('token')}).then((res) => {
				    	  if(res.data.Result>0){
					    	  if(res.data.Result=='70001') _this.$router.push('/login');
					          _this.$message.error(res.data.Message);
					          _this.$refs.multipleTable.toggleRowSelection(_this.productlists[i]);
				          }else{
				           	  var data=Base64.decode(res.data.Data);
				              if(data==1) {
				            	  _this.multipleSelection.push(e);
				              }else if(data==2) {
				            	  _this.$confirm(e.name+'库存不足，出库时将作为欠货商品处理，您是否要添加该商品', '提示', { type: 'warning' }).then(() => {
					        		  _this.multipleSelection.push(e);
						          }).catch(() => {
						        	  _this.$refs.multipleTable.toggleRowSelection(_this.productlists[i]);
						        	  _this.pclickstatus[i]=0;
						          });
				              }
				                        
				          }
				      }).catch((res) => {
				        	
				      });
    			  }
    		  });
    	
    	  });
    	
    	
    	  if(val) { //商品勾选状态全部置为1
			  this.pclickstatus.forEach(function(e,index) {
				  this.pclickstatus[index]=1;	
			  });
		  }else { //商品勾选状态全部置为0
			  this.pclickstatus.forEach(function(e,index) {
				  this.pclickstatus[index]=0;	
			  });
		  }	
      },
      
      
      /** 商品出库 **/
      addSave(){    
          this.addProductLoading=true;
          var resource = this.$resource(this.url);
          resource.save({act:'addproduct',id:this.productquery.oid,productid:this.multipleSelection,token:this.$cookies.get('token'),baseorderid:this.editparam.baseorderid,ordertype:this.editparam.ordertype}).then((res) => {
              if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	              this.addProductLoading=false;
              }else{
                  this.$message.success(res.data.Message);
                  this.addDialog=false;
                  this.addProductLoading=false;
                  this.getdetailinfos(this.editparam.baseorderid);
              }
          }).catch((res) => {
              //this.$message.error(this.GLOBAL.errortext);
              this.addDialog=false;
              this.addProductLoading=false;
          });
    },   
    
    
    
    /** 修改每页条数 **/
    changepagevlaue() {
    	var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
	    resource.query({act:'changepagesize',id:88,num:this.rollpage,token:this.$cookies.get('token')}).then((res) => {
	    	if(res.data.Result>0){
		    	if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
	        }else{
		        this.changepage();
	        }
	    }).catch((res) => {
	        //this.$message.error(this.GLOBAL.errortext);
	    });
    },
    
    /** 设置分页设置 **/
    changepage() {
    	var number=this.rollpage; //系统设置的每页条数
    	this.prtotal=this.printlists.goods.length; //总条数
    	this.prpage=[];
    	this.prollpage=[];
    	
    	if(number >= this.prtotal) {
    		this.prpage.push({id:1});
    		this.prollpage.push({startpage:0,endpage:number});
    		this.allprintpage=1;
    	}else {
    		var tnumber=parseInt(this.prtotal/number);
    		var lnumber=this.prtotal%number;
    		var index;
    		var start;
    		var end;
    		lnumber > 0 ? tnumber++ : '';
    		this.allprintpage=tnumber;
    		
    		for (var i=0;i<tnumber;i++) {
				index=i+1;
				this.prpage.push({id:index});
				start=i*number;
				end=index*number-1;
				this.prollpage.push({startpage:start,endpage:end});
			}
    	}
    },
    
    
    /** 获取默认发货仓库id **/
    getdefaultwarehouse() {
    	var resource = this.$resource(this.GLOBAL.domain+"Manager/index");
	    resource.query({act:'getdefaultwarehouse',token:this.$cookies.get('token')}).then((res) => {
	    	if(res.data.Result>0){
		    	if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
	        }else{
		        var result=JSON.parse(Base64.decode(res.data.Data));
		        this.defaultwarehouseid=result.warehouseid;
	        }
	    }).catch((res) => {
	        //this.$message.error(this.GLOBAL.errortext);
	    });
    },
    
    /** 确认完成订单 **/
    sureorder(item) {
    	this.$confirm('您是否确认该订单已经完成 ?', '提示', { type: 'warning' }).then(() => {
    		var resource = this.$resource(this.url);
	    	resource.query({act:'sureorder',id:item.id,token:this.$cookies.get('token')}).then((res) => {
		    	if(res.data.Result>0){
			    	if(res.data.Result=='70001') this.$router.push('/login')
			        this.$message.error(res.data.Message);
		        }else{
			        this.getList();
		        }
	    	}).catch((res) => {
	        	//this.$message.error(this.GLOBAL.errortext);
	    	});
    	}).catch((res) => {
	        //this.$message.error(this.GLOBAL.errortext);
	    });
    },
    
    
    /** 获取审核订单信息 **/
    getverifyinfo(id,type) {
        this.verifyandsendDialog=true;
        this.vosLoading=true;
    	var resource = this.$resource(this.url);
	    resource.query({act:'getverifyinfo',id:id,type:type,token:this.$cookies.get('token')}).then((res) => {
		    if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
		    }else{
				var result=JSON.parse(Base64.decode(res.data.Data));
				this.orders=result;
		    }
		    this.vosLoading=false;
	    }).catch((res) => {
	        //this.$message.error(this.GLOBAL.errortext);
	        this.vosLoading=false;
	    });
    },
	//////////////////////////////////////////////////////////////////////////////////////////////////  
	  
  }
}
</script>
<style>
.orderinfos {float:left;width:100%;padding:10px 0 20px 0}
.orderinfos span {float:left;width:33.3%;text-align:left;font-size:15px;margin-top:8px}
</style>


// WEBPACK FOOTER //
// src/components/home/Pdorder.vue